
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { BAIconsMixin, AuthMixin, StringsMixin, AthleteRoutingMixin, PartnersRoutingMixin, MyAthleteMixin, VuetifyMixin, ShowcaseEventMixin } from '@/mixins';
import { UpgradeNowMixin } from '@/mixins/UpgradeNowMixin';

import BestAthletesLogo from '../ui/BestAthletesLogo.vue';
import EventsNavItems from './EventsNavItems.vue';
import { BAEventModel } from '@/models';

@Component({
	components: {
		BestAthletesLogo,
		EventsNavItems,
	},
})
export default class AthleteSideNav extends Mixins(BAIconsMixin, AuthMixin, StringsMixin, AthleteRoutingMixin, PartnersRoutingMixin, MyAthleteMixin, UpgradeNowMixin, VuetifyMixin, ShowcaseEventMixin){
	@Prop({ default: true, type: Boolean }) value: boolean;

	mounted() {
        this.loadCurrentShowcaseEvents();
	}

	mini = false;
	listHome: boolean = false;
	listTeams: boolean = false;
	listRegistrations: boolean = false;
	listPerformance: boolean = true;
	listRecruitment: boolean = false;
	listCalendar: boolean = false;
	listPartners: boolean = false;

	get HasEvents(): boolean {
		if( !this.TheAthleteProfile ) return false;
		return this.TheAthleteProfile?.hasEvents || this.TheAthleteProfile?.hasFutureSchedule();
	}

	get HasRegistrations(): boolean {
		return this.TheAthleteProfile?.hasRegistrations;
	}

	get ShowcaseEvents(): Array<BAEventModel> {
		if( !this.HasShowcaseEvents ) return [];
		if( !this.TheAthleteProfile ) return this.showcaseEvents;

		const sportShowcaseEvents = this.showcaseEvents.filter(ev => ev.sportName === this.TheAthleteProfile.SportName)
		return sportShowcaseEvents.filter(ev => !this.TheAthleteProfile.hasEvent(ev.id))
	}
}
